import {ChangeDetectorRef, Component} from "@angular/core";
import {AbstractEditPage, PageContentMode} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {DocketPrintingRuleEntityModel} from "../docket-printing-rule-entity-model.service";
import {MetaTagDefinitionData, MetaTagType} from "../../../catalogue/meta-tag/meta-tag.data";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {
    DocketPrinterDownloadQueueStatsAction,
    DocketQueueStatsDownloadService
} from "../docket-queue-stats-download.service";
import * as FileSaver from "file-saver";

@Component({
    selector: "wbo-docket-printing-rule-edit-page",
    templateUrl: "./docket-printing-rule-edit-page.component.html",
    providers: [
        provideEntityModel(DocketPrintingRuleEntityModel),
        DocketQueueStatsDownloadService
    ]
})
export class DocketPrintingRuleEditPageComponent extends AbstractEditPage {

    MetaTagType = MetaTagType;
    EditMode = EditMode;

    constructor(public model: DocketPrintingRuleEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService,
                private docketPrinterDownloadQueueStatsService: DocketQueueStatsDownloadService) {
        super(changeDetectorRef, responsiveService);
        this.pageState.contentMode = PageContentMode.DETAILED;
    }

    get tagsPlaceholder(): any {
        return this.model.data.matchNoTags ? "wbo.meta-tag.option.modifier.matchNoTags"
            : "wbo.order-processor.edit.option.docketSelectorType.allProducts";
    }

    get docketSelectorsSelected(): boolean {
        return this.model.data.tags.length > 1 || (this.model.data.tags.length === 1 && this.model.data.tags[0].metaTagDefinitionId !== MetaTagDefinitionData.MATCH_UNTAGGED_ITEM);
    }

    changeSite(): void {
        this.model.data.webTerminalIds = [];
    }

    async downloadQueueCapacityStats(): Promise<void> {
        const data: any = await this.docketPrinterDownloadQueueStatsService.performAction(new DocketPrinterDownloadQueueStatsAction(this.model.data.id));
        FileSaver.saveAs(new Blob([data.csvData]), "docket-queue-stats.csv");
    }
}
